import { useState, useEffect } from 'react';
import { API, getAuthHeader } from '../App';
import axios from 'axios';
import { toast } from 'sonner';
import { 
  Brain, Plus, Edit2, Trash2, Save, X, Search, 
  MessageCircle, Loader2, CheckCircle, XCircle, Send,
  BookOpen, Tag
} from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

export default function IAPage() {
  var itensState = useState([]);
  var itens = itensState[0];
  var setItens = itensState[1];
  var loadingState = useState(true);
  var loading = loadingState[0];
  var setLoading = loadingState[1];
  var editandoState = useState(null);
  var editando = editandoState[0];
  var setEditando = editandoState[1];
  var formState = useState({ pergunta: '', resposta: '', categoria: 'geral' });
  var form = formState[0];
  var setForm = formState[1];
  var salvandoState = useState(false);
  var salvando = salvandoState[0];
  var setSalvando = salvandoState[1];
  var buscaState = useState('');
  var busca = buscaState[0];
  var setBusca = buscaState[1];
  var testeState = useState({ mensagem: '', resposta: '', loading: false });
  var teste = testeState[0];
  var setTeste = testeState[1];
  var showNovoState = useState(false);
  var showNovo = showNovoState[0];
  var setShowNovo = showNovoState[1];

  var categorias = ['geral', 'suporte', 'comercial', 'financeiro', 'movel', 'fibra', 'portabilidade', 'ativacao'];

  useEffect(function() { carregarItens(); }, []);

  function carregarItens() {
    setLoading(true);
    axios.get(API + '/ia/base-conhecimento', { headers: getAuthHeader() })
      .then(function(res) { setItens(res.data.itens || []); setLoading(false); })
      .catch(function() { toast.error('Erro ao carregar'); setLoading(false); });
  }

  function salvarItem() {
    if (!form.pergunta.trim() || !form.resposta.trim()) {
      toast.error('Pergunta e resposta são obrigatórios');
      return;
    }
    setSalvando(true);
    
    if (editando && editando !== 'novo') {
      axios.put(API + '/ia/base-conhecimento/' + editando, form, { headers: getAuthHeader() })
        .then(function() { toast.success('Atualizado!'); setEditando(null); carregarItens(); setSalvando(false); })
        .catch(function() { toast.error('Erro ao atualizar'); setSalvando(false); });
    } else {
      axios.post(API + '/ia/base-conhecimento', form, { headers: getAuthHeader() })
        .then(function() { toast.success('Adicionado!'); setEditando(null); setShowNovo(false); setForm({ pergunta: '', resposta: '', categoria: 'geral' }); carregarItens(); setSalvando(false); })
        .catch(function() { toast.error('Erro ao adicionar'); setSalvando(false); });
    }
  }

  function removerItem(id) {
    if (!window.confirm('Tem certeza que deseja remover?')) return;
    axios.delete(API + '/ia/base-conhecimento/' + id, { headers: getAuthHeader() })
      .then(function() { toast.success('Removido!'); carregarItens(); })
      .catch(function() { toast.error('Erro ao remover'); });
  }

  function toggleAtivo(item) {
    axios.put(API + '/ia/base-conhecimento/' + item.id, { ativo: !item.ativo }, { headers: getAuthHeader() })
      .then(function() { carregarItens(); })
      .catch(function() { toast.error('Erro'); });
  }

  function testarIA() {
    if (!teste.mensagem.trim()) return;
    setTeste({ ...teste, loading: true, resposta: '' });
    axios.post(API + '/ia/testar', { mensagem: teste.mensagem }, { headers: getAuthHeader() })
      .then(function(res) {
        setTeste({ 
          ...teste, 
          loading: false, 
          resposta: res.data.resposta || 'Sem resposta',
          transferir: res.data.transferir
        });
      })
      .catch(function() { setTeste({ ...teste, loading: false, resposta: 'Erro ao testar' }); });
  }

  var itensFiltrados = itens.filter(function(i) {
    if (!busca) return true;
    var b = busca.toLowerCase();
    return (i.pergunta || '').toLowerCase().includes(b) || 
           (i.resposta || '').toLowerCase().includes(b) ||
           (i.categoria || '').toLowerCase().includes(b);
  });

  return (
    <div className="space-y-6 p-6" data-testid="ia-page">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
            <Brain className="w-7 h-7 text-purple-600" />
            Inteligência Artificial
          </h1>
          <p className="text-sm text-slate-500 mt-1">Gerencie a base de conhecimento e teste a IA</p>
        </div>
        <Button onClick={function() { setShowNovo(true); setForm({ pergunta: '', resposta: '', categoria: 'geral' }); }} data-testid="novo-conhecimento-btn">
          <Plus className="w-4 h-4 mr-2" />Novo Conhecimento
        </Button>
      </div>

      {/* Testar IA */}
      <Card className="border-purple-200 bg-purple-50/50">
        <CardHeader className="pb-3">
          <CardTitle className="text-base flex items-center gap-2 text-purple-800">
            <MessageCircle className="w-5 h-5" />
            Testar IA
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex gap-2">
            <Input 
              placeholder="Digite uma mensagem como se fosse o cliente..."
              value={teste.mensagem}
              onChange={function(e) { setTeste({ ...teste, mensagem: e.target.value }); }}
              onKeyDown={function(e) { if (e.key === 'Enter') testarIA(); }}
              className="bg-white"
              data-testid="teste-ia-input"
            />
            <Button onClick={testarIA} disabled={teste.loading} data-testid="teste-ia-btn">
              {teste.loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
            </Button>
          </div>
          {teste.resposta && (
            <div className="mt-3 p-3 bg-white rounded-lg border">
              <div className="flex items-center gap-2 mb-1">
                <Brain className="w-4 h-4 text-purple-600" />
                <span className="text-xs font-medium text-purple-600">Resposta da IA</span>
                {teste.transferir && (
                  <span className="text-xs bg-orange-100 text-orange-700 px-2 py-0.5 rounded-full">Transfere para atendente</span>
                )}
              </div>
              <p className="text-sm text-slate-700 whitespace-pre-wrap">{teste.resposta}</p>
            </div>
          )}
        </CardContent>
      </Card>

      {/* Formulário Novo */}
      {showNovo && (
        <Card className="border-green-200 bg-green-50/50">
          <CardHeader className="pb-3">
            <CardTitle className="text-base text-green-800">Adicionar Conhecimento</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <div>
              <label className="text-xs text-slate-500 mb-1 block">Categoria</label>
              <select 
                className="w-full border rounded-md px-3 py-2 text-sm"
                value={form.categoria}
                onChange={function(e) { setForm({ ...form, categoria: e.target.value }); }}
              >
                {categorias.map(function(c) { return <option key={c} value={c}>{c.charAt(0).toUpperCase() + c.slice(1)}</option>; })}
              </select>
            </div>
            <div>
              <label className="text-xs text-slate-500 mb-1 block">Pergunta / Situação *</label>
              <Input value={form.pergunta} onChange={function(e) { setForm({ ...form, pergunta: e.target.value }); }} placeholder="Ex: Como configurar o roteador TP-Link?" className="bg-white" />
            </div>
            <div>
              <label className="text-xs text-slate-500 mb-1 block">Resposta *</label>
              <textarea 
                className="w-full border rounded-md px-3 py-2 text-sm min-h-[100px] resize-y"
                value={form.resposta}
                onChange={function(e) { setForm({ ...form, resposta: e.target.value }); }}
                placeholder="Ex: Para configurar o roteador TP-Link, acesse 192.168.0.1 no navegador..."
              />
            </div>
            <div className="flex gap-2 justify-end">
              <Button variant="ghost" onClick={function() { setShowNovo(false); }}>Cancelar</Button>
              <Button onClick={salvarItem} disabled={salvando} data-testid="salvar-conhecimento-btn">
                {salvando ? <Loader2 className="w-4 h-4 animate-spin mr-1" /> : <Save className="w-4 h-4 mr-1" />}
                Salvar
              </Button>
            </div>
          </CardContent>
        </Card>
      )}

      {/* Lista */}
      <Card>
        <CardHeader className="pb-3">
          <div className="flex items-center justify-between">
            <CardTitle className="text-base flex items-center gap-2">
              <BookOpen className="w-5 h-5 text-blue-600" />
              Base de Conhecimento ({itens.length} itens)
            </CardTitle>
            <div className="relative w-64">
              <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <Input className="pl-9 h-8 text-sm" placeholder="Buscar..." value={busca} onChange={function(e) { setBusca(e.target.value); }} />
            </div>
          </div>
        </CardHeader>
        <CardContent>
          {loading ? (
            <div className="flex items-center justify-center py-8 text-slate-400">
              <Loader2 className="w-5 h-5 animate-spin mr-2" />Carregando...
            </div>
          ) : itensFiltrados.length === 0 ? (
            <div className="text-center py-8 text-slate-400">
              <Brain className="w-8 h-8 mx-auto mb-2 opacity-50" />
              <p className="text-sm">{busca ? 'Nenhum resultado' : 'Nenhum conhecimento cadastrado'}</p>
            </div>
          ) : (
            <div className="space-y-2">
              {itensFiltrados.map(function(item) {
                var isEditando = editando === item.id;
                return (
                  <div key={item.id} className={"border rounded-lg p-3 transition-colors " + (item.ativo ? "bg-white hover:bg-slate-50" : "bg-slate-100 opacity-60")} data-testid="conhecimento-item">
                    {isEditando ? (
                      <div className="space-y-2">
                        <select className="w-full border rounded px-2 py-1 text-sm" value={form.categoria} onChange={function(e) { setForm({ ...form, categoria: e.target.value }); }}>
                          {categorias.map(function(c) { return <option key={c} value={c}>{c}</option>; })}
                        </select>
                        <Input value={form.pergunta} onChange={function(e) { setForm({ ...form, pergunta: e.target.value }); }} placeholder="Pergunta" />
                        <textarea className="w-full border rounded px-2 py-1 text-sm min-h-[80px]" value={form.resposta} onChange={function(e) { setForm({ ...form, resposta: e.target.value }); }} />
                        <div className="flex gap-2 justify-end">
                          <Button size="sm" variant="ghost" onClick={function() { setEditando(null); }}>Cancelar</Button>
                          <Button size="sm" onClick={salvarItem} disabled={salvando}>
                            {salvando ? <Loader2 className="w-3 h-3 animate-spin mr-1" /> : <Save className="w-3 h-3 mr-1" />}Salvar
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <div className="flex items-start justify-between gap-3">
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 mb-1">
                            <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full">{item.categoria || 'geral'}</span>
                            {!item.ativo && <span className="text-xs bg-red-100 text-red-600 px-2 py-0.5 rounded-full">Desativado</span>}
                          </div>
                          <p className="font-medium text-sm text-slate-800">{item.pergunta}</p>
                          <p className="text-xs text-slate-500 mt-1 line-clamp-2">{item.resposta}</p>
                        </div>
                        <div className="flex items-center gap-1 shrink-0">
                          <Button size="sm" variant="ghost" onClick={function() { toggleAtivo(item); }} title={item.ativo ? 'Desativar' : 'Ativar'}>
                            {item.ativo ? <CheckCircle className="w-4 h-4 text-green-600" /> : <XCircle className="w-4 h-4 text-red-400" />}
                          </Button>
                          <Button size="sm" variant="ghost" onClick={function() { setEditando(item.id); setForm({ pergunta: item.pergunta, resposta: item.resposta, categoria: item.categoria || 'geral' }); }}>
                            <Edit2 className="w-4 h-4 text-blue-600" />
                          </Button>
                          <Button size="sm" variant="ghost" onClick={function() { removerItem(item.id); }}>
                            <Trash2 className="w-4 h-4 text-red-500" />
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
